/*
dilip      10/04/2022 3075154998 Datamanager- tabs name changed,in filter changed payload and api
saikrishna 10/06/2022 3075154998 Removed unecesarry console.log statements
Suresh Peddavoora 10/26/2022 3075154998  Added Class Name for Table Enhancements
Akhila  10/28/2022 3075154998 data manager ux changes
Lalitha    10/28/2022 3075154998 Modified payload in search Api for sorting
Suresh Peddavoora 10/28/2022 3075154998  Added Rows per screen text in table pagination
saikrishna 11/03/2022 3075154998 changed the paginationOptions
Dilip 11/03/2022 3075154998 Added filter code in delete popup
Raghu 11/30/2022 3075154998 Table footer styling fixes
*/

import React, {createRef, useEffect, useState} from 'react';
// import MaterialTable from "material-table";
import {Button, Grid, TablePagination} from '@material-ui/core';
import {SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import {tableIcons} from '../../../../../components/TableIcons';
import {httpPaginationPost, httpPaginationDelete} from '../../../../../util/Rest';
import {useDispatch} from 'react-redux';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import {tablePageRows} from '../../../../../constants/ReusableConstants';
// import OverrideRule from "./../../../../../components/OverrideRule/index";

export default function SearchDataManagerFilterTable({
  setValueCode,
  searchData,
  setFilterCode,
  setFilterCodeName,
  submit,
  setSubmit,
  setTabValue,
  // setIsCopyRowData,
  // setUsageState,
  userMetrixDelete,
  isDelete,
  setIsDelete,
  isLoading,
  // setDeleteUsage,
  // setFieldRowData,
  // fieldRowData,
  // isUsage,
  // setIsUsage,
}) {
  const [message, setMessage] = useState('');

  const columns = [
    {
      title: 'Filter Code',
      field: 'filterCode',
    },
    {
      title: 'Description',
      field: 'description',
      width: '2%',
      headerStyle: {textAlign: 'left', fontSize: 16},
    },
  ];
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  const [deleteData, setDeleteData] = useState({});
  const [status, setStatus] = useState(false);
  const tableRef = createRef();
  const dispatch = useDispatch();

  // useEffect(() => {
  //   setUsageState(false);
  // }, []);
  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit]);
  // useEffect(() => {
  //   setIsCopyRowData(false);
  // }, []);
  useEffect(() => {
    if (status === true) {
      tableRef.current.onQueryChange();
      setStatus(false);
    }
  }, [status]);
  const handleDelete = (rowData) => {
    setIsDelete(true);
    setDeleteData(rowData);

    // setDeleteUsage(true);
  };
  const handleDeleteClose = () => {
    setIsDelete(false);
  };
  const handleSubmit = () => {
    httpPaginationDelete(`dmfilter/delete/filter/${deleteData?.filterCode}`)
      .then((response) => {
        if (response?.status === 200) {
          setIsDelete(false);
          setStatus(true);
          setMessage(response?.response);
          setTimeout(() => {
            setMessage('');
          }, 3000);
        }
      })

      .catch((error) => {
        console.log(error);
      });
  };
  // const handleDeleteUsage = () => {
  //   // if (userMetrixDelete) {
  //   //   setFieldRowData(deleteRowInfo);
  //   //   setValueCode(2);
  //   // } else {
  //   //   handleSubmit();
  //   // }
  // };
  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleDeleteClose}
        title="Delete Data Manager Filter"
        value={
          userMetrixDelete ?
            'This rule group is already being used' :
            `Are you sure you want to delete this ${deleteData?.filterCode} Filter code ?`
        }
        buttonCondition={userMetrixDelete}
        handleSubmit={handleSubmit}
      />

      {/* <OverrideRule
        dialogTitle="Delete Rule Group"
        // dialogOpen={isUsage}
        // dialogClose={() => setIsUsage((state) => !state)}
        title="This Business Rule Engine has been used in the following frameworks."
        data={usageFilter?.placeResponse}
        isOverRide={false}
      /> */}
      <Grid item xs={12}>
        <div className="custom-table custom-actions-icon custom-toolbar-icons global-field-table">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            isLoading={isLoading}
            data={(query) =>
              new Promise((resolve) => {
                const url = `dmfilter/search/all/filter`;
                const bodyObj = {


                  recordType: '',
                  description: searchData?.description ? searchData?.description : '',
                  limit: query.pageSize ? query.pageSize : null,
                  filterCode: searchData?.name ? searchData.name : '',
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                };
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObject;

                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(data.length === 1);
                        setFilterCode('');
                        setFilterCodeName('');
                        setSubmit(false);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              pageSize: rows,
              toolbar: true,
              toolbarButtonAlignment: 'left',
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            localization={{
              body: {editRow: {deleteText: 'Are you sure you want to delete this filter?'}},
            }}
            actions={[
              {
                icon: () => (
                  <>
                    <Button
                      type="button"
                      variant="outlined"
                      className={`search-btn`}
                      // disabled={dataCount === 0}
                    >
                      Add Filter
                    </Button>
                  </>
                ),
                isFreeAction: true,
                onClick: (event) => {
                  setTabValue(1);
                },
              },
              // {
              //   icon: () => (
              //     <>
              //       <FileCopyIcon />
              //     </>
              //   ),
              //   tooltip: "copy",
              //   onClick: (event, rowData) => {
              //     setFilterCode(rowData?.id);
              //     setFilterCodeName(rowData?.name);
              //     setIsCopyRowData(true);
              //     setValueCode(1);
              //   },
              // },
              // {
              //   icon: "visibility",
              //   tooltip: "Usage",
              //   onClick: (event, rowData) => {
              //     setDeleteUsage(false);
              //     dispatch(fetchFilterUsage(rowData.name));
              //   },
              // },
              {
                icon: () => (
                  <>
                    <DeleteOutlineOutlinedIcon />
                  </>
                ),
                tooltip: 'Delete',
                onClick: (event, rowData) => {
                  handleDelete(rowData);
                  // dispatch(fetchFilterUsage(rowData.name));
                },
              },
              // commented for future use
              // {
              //   icon: () => (
              //     <>
              //       <Button
              //         type="button"
              //         variant="contained"
              //         className={`themeing-buttons ${classes.buttonRoot}`}
              //         color="primary"
              //       >
              //         Print Usage
              //       </Button>
              //     </>
              //   ),
              //   tooltip: "Print Usage",
              //   isFreeAction: true,
              //   onClick: (event) => {},
              // },
              // {
              //   icon: () => (
              //     <>
              //       <Button
              //         variant="contained"
              //         className={`themeing-buttons ${classes.buttonRoot}`}
              //         onClick={() => {
              //           dispatch(
              //             printFilter({
              //               description: searchData?.description ? searchData?.description : "",
              //               name: searchData?.name ? searchData.name : "",
              //             })
              //           );
              //         }}
              //       >
              //         Print
              //       </Button>
              //     </>
              //   ),
              //   tooltip: "Print",
              //   isFreeAction: true,
              // },
            ]}
            onRowClick={(event, rowData) => {
              setFilterCode(rowData?.filterCode);
              setFilterCodeName(rowData?.name);
              setTabValue(1);
              // dispatch(rowData.)
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
          />
          {message && <SuccessSnackbar successMsg={message} />}
        </div>
      </Grid>
    </>
  );
}
